export default __webpack_public_path__ + "slices/main/assets/public/media/logo-bar-slack-beige-bg@2x.4a1b31184ff9f4a7e86b1acb916fe43d.png";